import { TargetFormationBase } from './base/target-formation-base';

export class TargetFormation extends TargetFormationBase { }